



























// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { TableRowProps, tableRowProps } from '../../../../../../abstract/components/Table'

import { DashmixButton } from '../../../atoms/Button'
import { DashmixCheck } from '../../../atoms/Check'
import { DashmixDropdown, DashmixDropdownItem } from '../../Dropdown'
import { DashmixIconName } from '../../../atoms/Icon'

import { DashmixTheme } from '../../../../contracts'

import { DashmixTableCell } from './TableCell'
import { useDashmixTableRow } from './TableRow.hooks'

/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const DashmixTableRow = defineComponent({
  name: 'DashmixTableRow',
  components: {
    DashmixButton,
    DashmixCheck,
    DashmixDropdown,
    DashmixDropdownItem,
    DashmixTableCell
  },
  props: tableRowProps,

  setup (props: TableRowProps, ctx: SetupContext) {
    return { ...useDashmixTableRow(props, ctx), DashmixIconName }
  }
})

export default DashmixTableRow
